import { useEffect, useState } from "react";
import { gql } from "@urql/core";
import { useQuery } from "urql";

const query = gql`
  query MyQuery($name: String) {
    programs(where: { name: { _eq: $name } }) {
      id
      name
      description
      image
      background
      short_description
      video
      class_headers(
        order_by: { name: asc }
        where: { deleted_at: { _is_null: true } }
      ) {
        name
        description
        cover
        category
        class_registrations {
          end_date
        }
      }
    }
  }
`;

export default function useProgramName(name) {
  const [data, setData] = useState([]);
  const [program, setProgram] = useState({});

  const [{ data: tmpData, fetching, error }] = useQuery({
    query: query,
    variables: {
      name: `${name}`,
    },
  });

  useEffect(() => {
    if (tmpData) {
      const arr = [];
      for (const item of tmpData.programs[0].class_headers) {
        const body = {
          name: item.name,
          link: item.name,
          description: item.description,
          cover: item.cover !== null ? item.cover : "/images/artikel8.webp",
          category: item.category,
        };
        arr.push(body);
      }
      setData(arr);
      setProgram(tmpData.programs[0]);
    }
  }, [tmpData]);

  return {
    data,
    program,
    fetching,
    error,
  };
}
